import {
  GCP_ONBOARDING_FIELDS,
  GCP_ONBOARDING_STEPS,
} from 'app/containers/Onboarding/GcpOnboarding/GcpOnboardingConstants';
import { accountTypeValidation } from 'app/containers/Onboarding/utils/OnboardingUtils';

export async function gcpDetailsValidation(currentScreen) {
  const errors = {};
  const billingTableName = currentScreen[GCP_ONBOARDING_FIELDS.BILLING_TABLE_NAME];
  const billingDatasetName = currentScreen[GCP_ONBOARDING_FIELDS.BILLING_DATASET_NAME];
  const serviceAccountKey = currentScreen[GCP_ONBOARDING_FIELDS.SERVICE_ACCOUNT_KEY];
  const accountName = currentScreen[GCP_ONBOARDING_FIELDS.ACCOUNT_NAME];
  const projectID = currentScreen[GCP_ONBOARDING_FIELDS.PROJECT_ID];
  const providerCurrency = currentScreen[GCP_ONBOARDING_FIELDS.PROVIDER_CURRENCY];

  if (!providerCurrency) {
    errors[GCP_ONBOARDING_FIELDS.PROVIDER_CURRENCY] = 'Provider currency is required';
  }

  if (!billingTableName) {
    errors[GCP_ONBOARDING_FIELDS.BILLING_TABLE_NAME] = 'Billing table name is required';
  } else {
    const billingTableNameRegex =
      /^(gcp_billing_export(_resource)?_v1_[0-9A-F]{6}_[0-9A-F]{6}_[0-9A-F]{6}|[a-z0-9_]+)$/;
    if (!billingTableNameRegex.test(billingTableName)) {
      errors[GCP_ONBOARDING_FIELDS.BILLING_TABLE_NAME] = 'Invalid billing table name format';
    }
  }

  if (!projectID) {
    errors[GCP_ONBOARDING_FIELDS.PROJECT_ID] = 'Project ID is required';
  }

  if (!billingDatasetName) {
    errors[GCP_ONBOARDING_FIELDS.BILLING_DATASET_NAME] = 'Billing dataset name is required';
  }

  if (!serviceAccountKey) {
    errors[GCP_ONBOARDING_FIELDS.SERVICE_ACCOUNT_KEY] = 'Service account key is required';
  }

  if (!accountName) {
    errors[GCP_ONBOARDING_FIELDS.ACCOUNT_NAME] = 'Account Name is required';
  }

  return errors;
}

export default async function useFormValidation(currentScreen, keycloakAuth) {
  switch (currentScreen.screen) {
    case GCP_ONBOARDING_STEPS.ACCOUNT_TYPE:
      return {
        errors: await accountTypeValidation(currentScreen, keycloakAuth),
        currentScreen,
      };
    case GCP_ONBOARDING_STEPS.CREATE_APP:
      return {
        errors: {},
        currentScreen,
      };
    case GCP_ONBOARDING_STEPS.GCP_DETAILS:
      return {
        errors: await gcpDetailsValidation(currentScreen),
        currentScreen,
      };
    case GCP_ONBOARDING_STEPS.PROCESS_DATA:
      return {
        errors: {},
        currentScreen,
      };
    case GCP_ONBOARDING_STEPS.K8S_INTEGRATION:
      return {
        errors: {},
        currentScreen,
      };
    default:
      return {
        errors: {},
        currentScreen,
      };
  }
}
